import React from 'react';
import {Link} from "react-router-dom";
import classnames from "classnames"

const OneMenuItem = (props) => {


    const currentRoute = props.item.slug ? "/catalog/"+props.item.slug+"/" : "/catalog/"

    let linkClass = classnames(
        "menu_item",
        {"active": window.location.pathname == currentRoute},
        {"alert": props.item.slug == 'sale'}
    )


    return (

        <Link
            className={linkClass}
            onMouseEnter={e => props.onMouseEnter(props.item)}
            // onMouseLeave={e => props.onMouseLeave(props.item)}
            style={{fontWeight:props.item.weight}}
            to={props.item.slug ? "/catalog/"+props.item.slug+"/" : "/catalog/"}>
            {props.item.name}
        </Link>

    );
};

export default OneMenuItem;